function initialState() {
  return {};
}

const state = initialState();

const getters = {};

const actions = {
  getAutoAssistConversationNames: async function(context, payload) {
    return await context.getters.CxmApiClient.ProcessRequest("post", "api/auto_assistant/conversation_name", payload).catch(err => err.response);
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/AutoAssistant.js